module.exports = __webpack_public_path__ + "img/setmeal.1b6ad368.svg";